import { Skeleton, useMediaQuery, useTheme } from "@mui/material";

const IntercomLoader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(980));

  if (isMobile) {
    return null;
  }

  return (
    <Skeleton
      variant="circular"
      height="48px"
      width="48px"
      sx={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
      }}
    />
  );
};

export default IntercomLoader;
